import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {FieldsModule} from '../../components/fields/fields.module';
import {UserStatisticsComponent} from './user-statistics.component';
import {UserStatisticsService} from '../../services/user-statistics.service';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        FieldsModule
    ],
    declarations: [
        UserStatisticsComponent
    ],
    providers: [
        UserStatisticsService
    ]
})
export class UserStatisticsModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/user-statistics/user-statistics.module.ts